import * as React from "react";
import { useTranslation } from "react-i18next";

interface WhoIHelpProps {}

const WhoIHelp: React.FC<WhoIHelpProps> = () => {
  const { t } = useTranslation();
  const bodyItems = t("landingPage.whoIHelp.body.items", {
    returnObjects: true,
  }) as string[];
  const brainItems = t("landingPage.whoIHelp.brain.items", {
    returnObjects: true,
  }) as string[];

  return (
    <section id="who-i-help" className="px-4 py-8 mt-[100px]">
      <div className="container mx-auto max-w-6xl">
        <h2
          className="section-heading mb-4 text-3xl md:text-4xl"
          style={{ opacity: 1, transform: "none" }}
        >
          {t("landingPage.whoIHelp.title")}
          <br className="hidden md:block" />
          {t("landingPage.whoIHelp.subtitle")}
        </h2>
        <p className="text-xl text-center text-muted-foreground mb-12 max-w-3xl mx-auto">
          {t("landingPage.whoIHelp.description")}
        </p>
        <div className="grid md:grid-cols-2 gap-8 items-center content-center justify-center">
          <div
            className="card-glass p-8 text-lg text-foreground"
            style={{ opacity: 1, transform: "none" }}
          >
            <h3 className="step-number mb-6 text-center">
              {t("landingPage.whoIHelp.body.title")}
            </h3>
            <ul className="space-y-4">
              {bodyItems?.map((item, index) => (
                <li key={index} className="text-center">
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div
            className="card-glass p-8 text-lg text-foreground"
            style={{ opacity: 1, transform: "none" }}
          >
            <h3 className="step-number text-center">
              {t("landingPage.whoIHelp.brain.title")}
            </h3>
            <ul className="space-y-4">
              {brainItems?.map((item, index) => (
                <li key={index} className="text-center">
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export { WhoIHelp };
